export const getSmartBuildLink = (smartbuildJobId: string | undefined) =>
  smartbuildJobId ? `https://postframesolver.azurewebsites.net/Framer/Edit/${smartbuildJobId}` : undefined;
